<template>
    <v-card class="elevation-10">
        <v-card-title style="background:#6499faff; color: white;">{{ $t('sportClass.form') }}</v-card-title>
        <v-divider class="mx-4" />
        <v-card-text>
            <v-form :readonly="readOnly">
                <v-row>
                    <v-col cols="6" lg="4">
                        <v-text-field
                            v-model="sportClass.name"
                            :label="$t('sportClass.name')"
                            :clearable="clearable"
                        />
                    </v-col>
                    <v-col cols="6" lg="4">
                        <v-autocomplete
                            v-model="sportClass.sport"
                            :items="sports"
                            :item-text="sport => sport.name"
                            :loading="loading"
                            :label="$t('sportClass.selectSport')"
                            hide-details
                            chips
                            clearable
                            return-object
                        />
                    </v-col>
                    <v-col cols="6" lg="4">
                        <v-autocomplete
                            v-model="sportClass.coach"
                            :items="coaches"
                            :item-text="coach => coach.name + ' ' + coach.lastName"
                            :loading="loading"
                            :label="$t('sportClass.selectCoaches')"
                            hide-details
                            chips
                            clearable
                            return-object
                        />
                    </v-col>
                </v-row>
            </v-form>
        </v-card-text>
        <v-card-actions v-if="mode !== 'show'" class="submit-button-wrapper">
            <v-btn :loading="loading" class="mx-2 white--text" :disabled="shouldDisableSubmit()" large color="black" @click="onSubmit">
                {{ $t('button.submit') }}
            </v-btn>
            <v-btn class="mx-2 white--text" large color="red" @click="$router.go(-1)">
                {{ $t('button.cancel') }}
            </v-btn>
        </v-card-actions>
        <alert :show-alert="showAlert" :message="message" :type="type" />
    </v-card>
</template>

<script>
    import sportService from '@/services/sport'
    import coachService from '@/services/coach'
    import sportClassService from '@/services/sportClass'
    import Alert from '@/components/Alert'

    export default {
        name: 'SportClassForm',
        components: { Alert },
        data: () => {
            return {
                showAlert: false,
                dialog: false,
                message: null,
                type: null,
                mode: null,
                readOnly: false,
                clearable: true,
                loading: false,
                startDate: null,
                endDate: null,
                sportClass: {},
                coaches: [],
                sports: [],
                mandatoryField: [
                    v => !!v || 'Field is required'
                ],
                search: null
            }
        },
        computed: {
        },
        created() {
            this.mode = this.$route.params.mode
            if (this.mode === 'show') {
                this.readOnly = true
                this.clearable = false
            }
            if (this.$route.params.sportClassId) {
                sportClassService.getSportClass(this.$route.params.sportClassId).then(resp => {
                    this.sportClass = resp.data
                })
            }
            this.fetchAllSports()
            this.fetchAllCoaches()
        },
        methods: {
            updateSportClass() {
                this.dialog = false
                sportClassService.getSportClass(this.$route.params.sportClassId).then(resp => {
                    this.sportClass = resp.data
                })
            },
            setAlert(message, type) {
                this.showAlert = true
                this.message = message
                this.type = type
                setTimeout(() => { this.showAlert = false }, 7000)
            },
            shouldDisableSubmit() {
                return false
            },
            onEdit() {
                this.$router.push(`/sportClasses/${this.sportClass.id}/edit`)
            },
            createSportClass() {
                sportClassService.createSportClass(this.sportClass).then(sportClassResponse => {
                    this.loading = false
                    this.$router.push(`/sportClasses`)
                }).catch((error) => {
                    this.loading = false
                    this.setAlert(error.response.data.message, 'error')
                })
            },
            editSportClass() {
                sportClassService.updateSportClass(this.sportClass.id, this.sportClass).then(sportClassResponse => {
                    this.loading = false
                    this.$router.push(`/sportClasses`)
                }).catch((error) => {
                    this.loading = false
                    this.setAlert(error.response.data.message, 'error')
                })
            },
            async onSubmit() {
                this.loading = true
                if (this.mode === 'edit') {
                    this.editSportClass()
                } else if (this.mode === 'create') {
                    this.createSportClass()
                } else {
                    this.createSportClass()
                }
            },
            fetchAllSports() {
                sportService.getSports().then(resp => {
                    this.sports = resp.data.content
                })
            },
            fetchAllCoaches() {
                coachService.getCoaches().then(resp => {
                    this.coaches = resp.data.content
                })
            }
        }

    }
</script>
<style>
.tox .tox-editor-header {
    z-index: 0 !important;
}
.tox .tox-statusbar {
    display: none !important;
}

.tox .tox-toolbar--scrolling {
    flex-wrap: wrap !important;
}
.tox.tox-tinymce.tox-platform-touch {
    height: 40vh !important;
    min-height: 350px;
}
</style>
<style scoped>
.v-menu__content{
    background-color: white!important;
    overflow-y: hidden!important;
}
.body-label {
    color: rgba(0, 0, 0, 0.6);
}
.body-editor {
    margin-bottom: 2vh;
}
.edit-button-wrapper {
    width: 100%;
    display: flex;
    justify-content: flex-end;
}

.submit-button-wrapper {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 2vh;
}

.img-preview {
    max-width: 70%;
    margin: 0 auto;
}

.image-input {
    padding: 20px;
    width: 100%;
    border-style: groove;
    border: #D3D3D3 solid 2px;
    border-radius: 15px 50px;
    margin-top: 1vh;
}

.green-border {
    border-color: green;
}

.delete-btn {
    display: flex;
    justify-content: flex-end;
}
</style>
